import Toggle from "../../../components/Toggle";

export default function TipActStep({ data, errors, update }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
      <Toggle
        label="Prelungirea contractului"
        description="Contractul va fi prelungit cu o nouă dată de încetare"
        checked={!!data.prelungire}
        onChange={() => update("prelungire")(!data.prelungire)}
      />
      <Toggle
        label="Modificarea chiriei"
        description="Chiria lunară se modifică (majorare sau reducere)"
        checked={!!data.modificareChirie}
        onChange={() => update("modificareChirie")(!data.modificareChirie)}
      />
      <Toggle
        label="Modificarea altor clauze"
        description="Se modifică alte prevederi din contractul original"
        checked={!!data.modificareClauze}
        onChange={() => update("modificareClauze")(!data.modificareClauze)}
      />
      {errors.tipAct && (
        <p style={{
          fontSize: "13px",
          color: "#e53e3e",
          margin: "4px 0 0 0",
          fontFamily: "'DM Sans', sans-serif",
        }}>
          {errors.tipAct}
        </p>
      )}
    </div>
  );
}
